import { render, staticRenderFns } from "./AddTeamMemberNewAccount.vue?vue&type=template&id=6a25a375&scoped=true&"
import script from "./AddTeamMemberNewAccount.vue?vue&type=script&lang=js&"
export * from "./AddTeamMemberNewAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a25a375",
  null
  
)

export default component.exports